import { useThemeStore, type Theme } from '../store/theme';

export interface ThemeColors {
  grid: string;
  axis: string;
  tooltipBg: string;
  tooltipBorder: string;
  tooltipLabel: string;
  line: string;
}

const LIGHT: ThemeColors = {
  grid: '#EEEEF0',
  axis: '#6B6B76',
  tooltipBg: '#fff',
  tooltipBorder: '#EEEEF0',
  tooltipLabel: '#1A1A22',
  line: '#635BFF',
};

const DARK: ThemeColors = {
  grid: '#3C3C4A',
  axis: '#8E8E99',
  tooltipBg: '#24242E',
  tooltipBorder: '#3C3C4A',
  tooltipLabel: '#EDEDF0',
  line: '#8F85FF',
};

export function paletteFor(theme: Theme): ThemeColors {
  return theme === 'dark' ? DARK : LIGHT;
}

export function useThemeColors(): ThemeColors {
  const theme = useThemeStore((s) => s.theme);
  return paletteFor(theme);
}
